import React, { useEffect } from "react";
import Terms from "./Terms";

const Privacy = () => {
  useEffect(() => {
    const jumpToPrivacy = () => {
      const section = document.getElementById("privacy");
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    const timer = setTimeout(jumpToPrivacy, 0);
    return () => clearTimeout(timer);
  }, []);

  return <Terms />;
};

export default Privacy;
